import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Table, Button, Tag } from 'antd';
import { BulbFilled, SettingOutlined } from '@ant-design/icons';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import PopupComponent from "../util/DiscountCouponPopup";
// import WeeklyPopupComponent from "../util/WeeklyCouponPopup";
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import SelectCenter from "../util/SelectCenter";
import Filter from '../util/Filter';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import GetApiHost from '../util/GetApiHost';

let clear = false;
let name = '';
let phone = '';

let filterMode = {
    name : true,
    phone : true
}

let storage = {
    nameKeyword : '',
    phoneKeyword : '',
    popupMode : '',
    popupData : {}
}

function DiscountCoupon() {
    const [showPopup, setShowPopup] = useState(false);
    const [showWeeklyPopup, setShowWeeklyPopup] = useState(false);
    const [selectedCenter, setSelectedCenter ] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();
    
    const columns = [
        {
            title : '센터명',
            dataIndex : 'cname',
            key : 'cname'
        },
        {
            title : '이름',
            dataIndex : 'name',
            key : 'name'
        },
        {
            title : '연락처',
            dataIndex : 'phone',
            key : 'phone'
        },
        {
            title : '쿠폰명',
            dataIndex : 'coupon_name',
            key : 'coupon_name'
        },
        {
            title : '유효기간',
            dataIndex : 'val_date',
            key : 'val_date'
        },
        {
            title : '사용',
            dataIndex : 'is_use',
            key : 'is_use',
            render : is_use => {
                let color = is_use == 'Y' ? 'blue' : 'lightgray';
                let text = is_use == 'Y' ? '사용완료' : '미사용'
                return (
                    <Tag color={color}>
                        {text}
                    </Tag>
                )
            }
        },
        {
            title : '상태',
            dataIndex : 'state',
            key : 'state',
            render : state => {
                let color = state == 'Y' ? 'green' : '#999';
                return (
                    <BulbFilled style={{color : color}} />
                )
            }
        },
        {
            title : '등록일',
            dataIndex : 'regdate',
            key : 'regdate',
            render : regdate => {
                return moment(regdate).format('YYYY-MM-DD HH:mm')
            }
        }
    ]

    const onClickRow = (record) => {
        return {
            onClick : () => {
                openPopup("edit", record)
            }
        }
    }
    
    function openPopup(mode, data) {
        setShowPopup(true);
        storage.popupMode = mode;
        storage.popupData = data;
    }

    function openSettingPopup() {
        alert('슈퍼쿠폰셋팅')
    }

    function closePopup(isUpdated) {
        setShowPopup(false);
        if(isUpdated === "updated"){
            getDataSource()
        }
    }

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
    }

    function handleClear(){
        storage.nameKeyword = '';
        storage.phoneKeyword = '';
        clear = true;
        getDataSource();
    }

    function handleFilter(filterData){
        storage.nameKeyword = filterData.nameKeyword;
        storage.phoneKeyword = filterData.phoneKeyword
        getDataSource();
    }
    
    function getDataSource(){
        if(clear === true){
            name = ''
            phone = '';
        }else{
            name = storage.nameKeyword;
            phone = storage.phoneKeyword;
        }
        let temp_cid = '';
        if(data.cid !== 'root'){
            temp_cid = data.cid
        }else{
            temp_cid = selectedCenter
        }

        (async function () {
            const api_host = GetApiHost();
            const result = await axios.post(api_host + '/discount_coupon/get_discount_coupon', {
                cid: temp_cid,
                nameKeyword : name,
                phoneKeyword : phone
            })
            setDataSource(result.data.rows);
        })();
    }

    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            dispatch({type:'SET', name:"CID", value:decodeResult.cid});
            dispatch({type:'SET', name:"LEVEL", value:decodeResult.level});
            getDataSource();
            setInterval(()=>{setIsLoading(false)}, 300); 
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();
    },[]);

    useEffect(()=>{
        if(data.cid === "root"){
            getDataSource();
        }
    },[selectedCenter]);

    // if (isLoading) return (
    //     <main className="main-container">
    //     <TopNav />
    //     <div className="content-wrapper">
    //     <MainNav />
    //     <Loader />
    //     </div>
    //     </main>
    // )

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner">
            <h3 style={{display : "inline-block"}}>할인쿠폰 관리</h3>
            {/* 슈퍼쿠폰 세팅 */}
            {/* <Button className="btn-primary" style={{float : "right"}} onClick={() => openSettingPopup()}><SettingOutlined style={{verticalAlign : "middle"}}/>슈퍼쿠폰 관리 </Button> */}
            <div className="content-component">
                <div className="content-header">
                <div>
                <Button className="add-button" onClick={() => openPopup("add", {})}><LocalActivityIcon /> &nbsp; 할인쿠폰 추가 </Button>
                </div>
                <SelectCenter 
                    onSelectedCenter={handleSelectedCenter}
                />
                </div>
                <div className="content-body">
                    <div className="table-header">
                        <div></div>
                        <div style={{display : "inline-flex"}}>
                        <Filter 
                            handleFilter = {handleFilter} 
                            handleClear = {handleClear}
                            mode = {filterMode}
                        />
                        </div>
                    </div>
                    <div className="table-body cursor">
                    <Table dataSource={dataSource} columns={columns} onRow={onClickRow} rowKey="seq" />
                    </div>
                </div>
            </div>
            {showPopup ? 
            <PopupComponent
                data = {storage.popupData}
                mode = {storage.popupMode}
                closePopup={closePopup}
            />
            : null
            }
            </div>
            </div>
        </main>
    )
}

export default DiscountCoupon;